import React from 'react';

import { useTranslations } from '~i18n/hooks';
import { NeuronImage } from '~shared/ui/atoms';
import { ButtonStroked } from '~shared/ui/molecules';

import PictureIcon from '../../../../../../public/img/sexting-pack/scaledPicture.svg';
import { ButtonsContainer } from './styles';

type TProps = {
	itemsLength: number;
	showPaid: boolean;
	cost: number;
	onOpenPack: () => void;
	onUnlockPack: () => void;
};

export const SextingPackActions = ({
	itemsLength,
	showPaid,
	cost,
	onOpenPack,
	onUnlockPack,
}: TProps) => {
	const t = useTranslations('Chats');

	return (
		<ButtonsContainer>
			<ButtonStroked size="M" leftIcon={<PictureIcon />} onClick={onOpenPack}>
				{itemsLength}
			</ButtonStroked>

			{showPaid ? (
				<ButtonStroked
					rightIcon={<NeuronImage />}
					size="M"
					onClick={onUnlockPack}
					data-name="unlock-sexting-pack"
				>
					{/* TODO: proper translation for cost with a template {number} */}
					{t('unlockSextingPackButtonTitle')} {cost}
				</ButtonStroked>
			) : (
				<ButtonStroked
					size="M"
					onClick={onOpenPack}
					data-name="open-sexting-pack-media"
				>
					{t('openSextingPackMediaButtonTitle')}
				</ButtonStroked>
			)}
		</ButtonsContainer>
	);
};
